import { http } from 'http';

export default {
  login: ({ operationGuid, cif, email }) => http.get(`/prospects/${operationGuid}/${cif}/${email}`),
  legalConditions: step => http.get(`/prospects/${step}/consentsgroups`)
};
